/* FlyHugz holiday + birthday pages: tiny renderer for the Claude Design components, plus the cart bridge.
   Only used by the fhx-* page templates (layout fhx-landing). Nothing else in the theme loads it. */
(function () {
  'use strict';
  var FHX = window.FHX = window.FHX || {};
  var CFG = window.FHX_CFG || {};
  FHX.cfg = CFG;
  FHX.instances = FHX.instances || {};

  /* ---------------- money ---------------- */
  var fmt = null;
  try { fmt = new Intl.NumberFormat(CFG.locale || 'en', { style: 'currency', currency: CFG.currency || 'USD' }); } catch (e) {}
  FHX.money = function (cents) {
    var v = Math.round(cents) / 100;
    if ((CFG.currency || 'USD') === 'USD') return '$' + v.toFixed(2);
    return fmt ? fmt.format(v) : v.toFixed(2) + ' ' + CFG.currency;
  };
  // Design copy is written in USD. Outside USD, swap each USD amount for the local one.
  var swaps = [];
  if ((CFG.currency || 'USD') !== 'USD') {
    var P = CFG.priceBogo, M = CFG.priceMask, S = CFG.priceSecret, m = FHX.money;
    var base = CFG.secretPage
      ? [['$14.97', .3 * S], ['$29.94', .6 * S], ['$34.93', .7 * S], ['$69.86', 1.4 * S], ['$49.90', S], ['$99.80', 2 * S]]
      : [['$24.95', P / 2], ['$49.90', P], ['$99.80', 2 * P], ['$199.60', 4 * P], ['$79.60', 4 * M], ['$179.40', 2 * P + 4 * M], ['$279.20', 4 * P + 4 * M], ['$399.20', 8 * P]];
    base.forEach(function (b) { swaps.push([b[0], m(b[1])]); });
    swaps.sort(function (a, b) { return b[0].length - a[0].length; });
  }
  function localise(html) {
    for (var i = 0; i < swaps.length; i++) html = html.split(swaps[i][0]).join(swaps[i][1]);
    return html;
  }

  /* ---------------- template renderer ---------------- */
  var VOID = { area: 1, base: 1, br: 1, col: 1, embed: 1, hr: 1, img: 1, input: 1, link: 1, meta: 1, source: 1, track: 1, wbr: 1 };
  var ONE = /^\s*\{\{([^}]+)\}\}\s*$/;
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function lookup(expr, scope) {
    expr = expr.trim();
    if (expr === 'true') return true;
    if (expr === 'false') return false;
    if (/^-?\d+(\.\d+)?$/.test(expr)) return +expr;
    var parts = expr.split('.'), v, found = false;
    for (var i = scope.length - 1; i >= 0; i--) {
      var o = scope[i];
      if (o != null && typeof o === 'object' && parts[0] in o) { v = o[parts[0]]; found = true; break; }
    }
    if (!found) return undefined;
    for (var j = 1; j < parts.length && v != null; j++) v = v[parts[j]];
    return v;
  }
  function interp(str, scope) {
    if (str.indexOf('{{') < 0) return str;
    return str.replace(/\{\{([^}]+)\}\}/g, function (_, e) { var v = lookup(e, scope); return v == null ? '' : String(v); });
  }
  function render(node, scope, ctx) {
    var out = '';
    for (var c = node.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3) { out += esc(interp(c.nodeValue, scope)); continue; }
      if (c.nodeType !== 1) continue;
      var tag = c.localName;
      if (tag === 'sc-for') {
        var lm = ONE.exec(c.getAttribute('list') || ''), list = lm ? lookup(lm[1], scope) : null, as = c.getAttribute('as');
        if (list && list.length) for (var i = 0; i < list.length; i++) { var o = {}; o[as] = list[i]; out += render(c, scope.concat([o]), ctx); }
        continue;
      }
      if (tag === 'sc-if') {
        var im = ONE.exec(c.getAttribute('value') || '');
        if (im && lookup(im[1], scope)) out += render(c, scope, ctx);
        continue;
      }
      out += '<' + tag;
      for (var a = 0; a < c.attributes.length; a++) {
        var at = c.attributes[a], n = at.name, val = at.value;
        if (n.indexOf('hint-') === 0) continue;
        if (n.slice(0, 2) === 'on') {
          var hm = ONE.exec(val), fn = hm ? lookup(hm[1], scope) : null;
          if (typeof fn === 'function') { out += ' data-fhx-' + n.slice(2) + '="' + ctx.h.length + '"'; ctx.h.push(fn); }
          continue;
        }
        out += ' ' + n + '="' + esc(interp(val, scope)) + '"';
      }
      out += '>';
      if (VOID[tag]) continue;
      out += render(c, scope, ctx) + '</' + tag + '>';
    }
    return out;
  }

  /* ---------------- DOM morph (position based, keeps videos alive) ---------------- */
  function syncAttrs(from, to) {
    var i, a;
    for (i = from.attributes.length - 1; i >= 0; i--) { a = from.attributes[i]; if (!to.hasAttribute(a.name)) from.removeAttribute(a.name); }
    for (i = 0; i < to.attributes.length; i++) { a = to.attributes[i]; if (from.getAttribute(a.name) !== a.value) from.setAttribute(a.name, a.value); }
  }
  function morph(from, to) {
    var fc = from.firstChild, tc = to.firstChild;
    while (tc) {
      var next = tc.nextSibling;
      if (!fc) { from.appendChild(tc); tc = next; continue; }
      var fnext = fc.nextSibling;
      if (fc.nodeType !== tc.nodeType || fc.nodeName !== tc.nodeName) from.replaceChild(tc, fc);
      else if (fc.nodeType === 3 || fc.nodeType === 8) { if (fc.nodeValue !== tc.nodeValue) fc.nodeValue = tc.nodeValue; }
      else { syncAttrs(fc, tc); morph(fc, tc); }
      fc = fnext; tc = next;
    }
    while (fc) { var n2 = fc.nextSibling; from.removeChild(fc); fc = n2; }
  }

  /* ---------------- component base ---------------- */
  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (p) {
    var s = typeof p === 'function' ? p(this.state) : p;
    for (var k in s) this.state[k] = s[k];
    if (this.__schedule) this.__schedule();
  };

  function mount(el) {
    var key = el.getAttribute('data-fhx-mount');
    var tplSrc = document.getElementById('fhx-tpl-' + key), codeSrc = document.getElementById('fhx-code-' + key);
    if (!tplSrc || !codeSrc) return;
    var tpl = document.createElement('template');
    tpl.innerHTML = tplSrc.textContent;
    var Comp = new Function('DCLogic', 'FHX', codeSrc.textContent + '\n;return Component;')(DCLogic, FHX);
    var inst = new Comp({});
    var ctx = { h: [] }, queued = false, lastHtml = '';
    function paint() {
      queued = false;
      var vals = inst.renderVals() || {};
      if (!vals.addToCart && inst.fhxAdd) vals.addToCart = function () { inst.fhxAdd(); };
      var nctx = { h: [] };
      var html = localise(render(tpl.content, [vals], nctx));
      ctx.h = nctx.h;
      if (html === lastHtml) return;
      lastHtml = html;
      var t = document.createElement('template');
      t.innerHTML = html;
      morph(el, t.content);
      var vids = el.querySelectorAll('video[autoplay]');
      for (var i = 0; i < vids.length; i++) { var v = vids[i]; v.muted = true; if (v.paused && !v.__fhxTried) { v.__fhxTried = 1; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }
    }
    inst.__schedule = function () { if (!queued) { queued = true; requestAnimationFrame(paint); } };
    el.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-fhx-click]');
      if (!t || !el.contains(t)) return;
      var fn = ctx.h[+t.getAttribute('data-fhx-click')];
      if (!fn) return;
      if (t.tagName === 'A') e.preventDefault();
      fn(e);
    });
    paint();
    if (inst.componentDidMount) inst.componentDidMount();
    FHX.instances[key] = inst;
    return inst;
  }

  /* ---------------- cart bridge ---------------- */
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function post(url, body) { return fetch(url, { method: 'POST', headers: J, credentials: 'same-origin', body: JSON.stringify(body || {}) }).then(function (r) { return r.json(); }); }
  FHX.getCart = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); };
  FHX.applyCode = function (code) { return post('/cart/update.js', { discount: code }); };
  FHX.replaceCart = function (items, code) {
    return post('/cart/clear.js').then(function () { return post('/cart/add.js', { items: items }); })
      .then(function () { return code ? FHX.applyCode(code) : null; });
  };
  function group(ids, props) {
    var by = {}, order = [];
    ids.forEach(function (id) { if (!by[id]) { by[id] = 0; order.push(id); } by[id]++; });
    return order.map(function (id) { return { id: +id, quantity: by[id], properties: props }; });
  }
  // Buy 2 Get 2 (2026-10-19): 4 pillows of the hidden "Buy 2 Get 2 Pillow Deal" product (one line per colour,
  // $24.95 each, outside the BOGO discount) + one REAL Premium Sleep Mask line per pillow colour, freed at
  // checkout by the automatic discount "4 FREE Sleep Masks" (buy 4 deal pillows, get 4 masks). Same mechanism
  // as the 7 Reasons listicle. The old combined "+ FREE Sleep Mask" variants hid the masks at checkout.
  var DEAL = [67771030798617, 67771030831385, 67771030864153, 67771030896921];
  var MASKS = [52041567633689, 52041567666457, 52749152813337, 53029349556505];
  function bogoItems(tier, paid, free) {
    var V = CFG.variants, deal = V.deal || DEAL, masks = V.maskLine || MASKS;
    var n = tier === 2 ? 2 : 1, cols = (paid || [0]).slice(0, n).concat((free || [1]).slice(0, n));
    while (cols.length < n * 2) cols.push(cols[0] || 0);
    var props = { _bid: 'fhx' + Date.now(), _uq: String(cols.length), _t: 'a', _src: 'fhx-' + CFG.page, _cur: CFG.currency };
    if (tier !== 2) return group(cols.map(function (c) { return V.bogoPlain[c]; }), props);
    props._bundle = 'b2g2'; props._was = (4 * CFG.priceBogo / 100).toFixed(2);
    props._paid = cols.slice(0, 2).join(','); props._free = cols.slice(2).join(',');
    var mp = { _freeGift: '1', _giftType: 'mask', _src: 'fhx-' + CFG.page };
    // Pillows: the plain BOGO variants, so "Buy 1 Get 1 Free!" shows 2 of them as Free at checkout. The masks are
    // freed by the "B2G2 free masks" app discount (flyhugz-checkout function), not by a Buy X Get Y discount.
    // /cart/add.js prepends one by one, so masks go first in the payload to land BELOW the pillows at checkout.
    return group(cols.map(function (c) { return masks[c]; }), mp).concat(group(cols.map(function (c) { return V.bogoPlain[c]; }), props));
  }
  FHX.bogoItems = bogoItems;
  FHX.colorOf = function (variantId) {
    var V = CFG.variants, id = +variantId, k, deal = V.deal || DEAL, masks = V.maskLine || MASKS;
    for (k = 0; k < 4; k++) {
      if (V.bogoPlain[k] === id) return { c: k, kind: 'plain' };
      if (V.bogoMask[k] === id) return { c: k, kind: 'mask' };
      if (deal[k] === id) return { c: k, kind: 'deal' };
      if (masks[k] === id) return { c: k, kind: 'maskline' };
      if (V.secret[k] === id) return { c: k, kind: 'secret' };
    }
    return null;
  };
  FHX.busy = false;
  function withBusy(p) { FHX.busy = true; document.documentElement.classList.add('fhx-busy'); return p.then(function (x) { FHX.busy = false; document.documentElement.classList.remove('fhx-busy'); return x; }, function (e) { FHX.busy = false; document.documentElement.classList.remove('fhx-busy'); throw e; }); }
  FHX.addBogo = function (tier, paid, free) {
    if (FHX.busy) return;
    withBusy(FHX.replaceCart(bogoItems(tier, paid, free))).then(FHX.openDrawer).catch(function () { location.href = '/cart'; });
  };
  FHX.addSecret = function (tier, paid, active) {
    if (FHX.busy) return;
    var n = tier === 2 ? 2 : 1, cols = (paid || [0]).slice(0, n);
    while (cols.length < n) cols.push(cols.length ? (cols[0] + 1) % 4 : 0);
    var items = group(cols.map(function (c) { return CFG.variants.secret[c]; }), { _src: 'fhx-' + CFG.page });
    if (active) { try { localStorage.setItem('fhxSecretActive', '1'); } catch (e) {} }
    withBusy(FHX.replaceCart(items, active ? 'SECRET30' : '')).then(FHX.openDrawer).catch(function () { location.href = '/cart'; });
  };

  /* drawer shell */
  FHX.openDrawer = function () {
    var w = document.getElementById('fhx-drawer');
    if (!w) { location.href = '/checkout'; return; }
    w.classList.add('is-open');
    document.documentElement.classList.add('fhx-lock');
    var d = FHX.instances.drawer;
    if (d && d.refresh) d.refresh();
  };
  FHX.closeDrawer = function () {
    var w = document.getElementById('fhx-drawer');
    if (w) w.classList.remove('is-open');
    document.documentElement.classList.remove('fhx-lock');
  };
  FHX.isOpen = function () { var w = document.getElementById('fhx-drawer'); return !!(w && w.classList.contains('is-open')); };

  function boot() {
    var els = document.querySelectorAll('[data-fhx-mount]');
    for (var i = 0; i < els.length; i++) { try { mount(els[i]); } catch (e) { if (window.console) console.error('fhx mount', e); } }
    var bd = document.getElementById('fhx-drawer-backdrop');
    if (bd) bd.addEventListener('click', FHX.closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') FHX.closeDrawer(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
